import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.availableApps.length)?_c(VBtn,{attrs:{"icon":""}},[_c(VMenu,{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c(VBtn,_vm._g({attrs:{"icon":""}},on),[_c(VIcon,[_vm._v("mdi-apps")])],1)]}}],null,false,3446354165)},[_c(VList,_vm._l((_vm.availableApps),function(app,i){return _c(VListItem,{key:i,attrs:{"href":app.url}},[_c(VIcon,{staticClass:"mr-2",attrs:{"color":app.color}},[_vm._v(" "+_vm._s(app.icon)+" ")]),_c(VListItemTitle,[_vm._v(_vm._s(_vm.$t(app.title)))])],1)}),1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }